<script setup lang="ts">
  import { useTemplateRef } from 'vue'

  defineProps<{
    multiple?: boolean,
    accept?: string,
  }>()

  const emit = defineEmits<{
    (e: 'change', files: File[]): void,
  }>()

  const model = defineModel<File[]>({ default: () => [] })

  const onChange = (event: Event) => {
    const files = (event.target as HTMLInputElement).files
    if (files) {
      model.value = Array.from(files)
    } else {
      model.value = []
    }

    // allow reselect new file immediately
    if (refInput.value) {
      refInput.value.value = ''
    }

    emit('change', model.value)
  }

  const refInput = useTemplateRef('refInput')
  const open = () => {
    refInput.value?.click()
  }
</script>

<template>
  <div>
    <input
      ref="refInput"
      type="file"
      :multiple="multiple"
      :accept="accept"
      class="hidden"
      @change="onChange">
    <slot :open="open"></slot>
  </div>
</template>
